// extracted by mini-css-extract-plugin
export var messageSideLeft = "_m4-1";
export var messageSideRight = "_m4-2";
export var orderLookupBubbleContainer = "_m4-0";
export var submitButton = "_m4-3";